import React, { useContext, useEffect, useRef, useState } from "react";
import "./PartIssue.css";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker";
import { DropdownsContext } from "../../../../../contexts/DropdownsContext";
import { Dropdowns } from "../../../../../components/Dropdowns/Dropdowns";
import Input from "../../../../../components/Inputs/Input";
import authService from "../../../../../services/authService";
const dropdownNames = {
  17: "locationId",
  19: "siteId",
  64: "partNumberId",
  20: "rackId",
  21: "shelfId",
  18: "binId",
  6: "uomId",
  74: "currencyId",
};
const mainTransaction = {
  locationId: null,
  siteId: null,
  user: "",
  createdDate: "",
  partsList: [],
};
export const PartIssue = () => {
  const [values, setValues] = useState({ ...mainTransaction });
  const [partSelected, setPartSelected] = useState(null);
  const [defaults, setDefaults] = useState({});
  const hideFieldsWhenDisabled = new Set(["Location", "Site", "AC", "WC"]);
  const [displayForm, setDisplayForm] = useState(false);
  const [dateRequestedCreated, setDateRequestedCreated] = useState(null);
  const { getUsername } = authService();
  const dropdownIds = [17, 19, 64, 20, 21, 18, 6, 74];
  const {
    dropdownsData,
    setDropdownsData,
    dropdownDefaultOptions,
    setDropdownIds,
  } = useContext(DropdownsContext);
  const fieldChangeMapper = {
    type: (value) => ({ locationId: value, siteId: null }),
  };

  useEffect(() => {
    getName();
    const interval = setInterval(() => {
      setDateRequestedCreated(new Date());
    }, 1000);
    setDropdownIds(dropdownIds);
    setDefaults({ ...values });
    return () => {
      clearInterval(interval);
    };
  }, []);
  const disabledSite = () => {
    if (values.locationId != null) {
      return false;
    }
    return true;
  };
  const getName = () => {
    let name = "Unknow Name";
    if (getUsername()) {
      name = getUsername();
    }
    setValues((prev) => {
      return {
        ...prev,
        ...{ ["userName"]: name },
      };
    });
  };
  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) setDisplayForm(true);
  }, [dropdownsData]);

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  
  const handleDropdownValueOption = (value, name, data, part) => {
    const updatedParts = values.partsList.map((p) => {
      if (p === part) {
        const updatedPart = {
          ...p,
          [name]: value[data], // guardar el ID o valor relevante
          completeValue: value, // opcional si usas esto para preselección
        };
  
        if (name === "partNumberId" && value?.category_id === 4) {
          updatedPart.isSerialized = true;
          updatedPart.sn = "";
        }
  
        return updatedPart;
      }
      return p;
    });
  
    setValues((prev) => ({
      ...prev,
      partsList: updatedParts,
    }));
  
    // Actualizar partSelected si es el mismo que se modificó
    if (part === partSelected) {
      const updatedSelected = updatedParts.find((p) => p === part || p === partSelected);
      setPartSelected(updatedSelected);
    }
  };
  const handleDropdownValue = (value, name, data) => {
    if (!value) {
      changeValue({ target: { name, value: null, completeValue: value } });
    } else {
      changeValue({
        target: { name, value: value[data], completeValue: value },
      });
    }
    setDefaults((prev) => ({
      ...prev,
      ...{ [name]: " " },
    }));
  };

  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };
  const addPart = () => {
    if (values.locationId == null || values.siteId == null) {
      return;
    }
    const newPart = {
      partNumberId: null,
      sn: "N/A",
      rackId: null,
      shelfId: null,
      binId: null,
      grn: "",
      isSerialized: false,
      batch: "",
      qty: "",
      uomId: null,
      cost: "",
      currencyId: null,
    };
    setValues((prev) => {
      const updatedParts = [...prev.partsList, newPart];
      setPartSelected(newPart); // Establecer como seleccionado
      return {
        ...prev,
        partsList: updatedParts,
      };
    });
  };

  const deletePart = (part, partIdx) => {
    setValues((prev) => {
      const newPartsList = [...prev.partsList];
      newPartsList.splice(partIdx, 1);
      return {
        ...prev,
        partsList: newPartsList,
      };
    });
  };
  const changeValue = (e) => {
    const { name, value, completeValue } = e.target;
    setValues((prev) => {
      return {
        ...prev,
        ...{ [name]: value },
      };
    });
  };
  return (
    <div className="part-issue-component">
      {displayForm && (
        <>
          <div className="part-issue-header">
            <div className="part-issue-form-row">
              <Dropdowns
                context={{
                  dropdownsData,
                  setDropdownsData,
                  setDropdownIds,
                  dropdownDefaultOptions,
                }}
                required={true}
                updateDropdown={updateDropdown}
                resetDropdownsReload={resetDropdownsReload}
                hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[17])}
                key={17}
                onOptionSelect={(value, data) =>
                  handleDropdownValue(value, dropdownNames[17], data)
                }
                showPagination={false}
                data={dropdownsData.find((e) => e.id === 17)}
                preSelectValue={defaults?.[dropdownNames[17]]}
              />
              <Dropdowns
                context={{
                  dropdownsData,
                  setDropdownsData,
                  setDropdownIds,
                  dropdownDefaultOptions,
                }}
                disabled={disabledSite()}
                required={true}
                updateDropdown={updateDropdown}
                resetDropdownsReload={resetDropdownsReload}
                hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[19])}
                key={19}
                onOptionSelect={(value, data) =>
                  handleDropdownValue(value, dropdownNames[19], data)
                }
                showPagination={false}
                data={dropdownsData.find((e) => e.id === 19)}
                preSelectValue={defaults?.[dropdownNames[19]]}
              />
              <button className="filled iconTextButton" onClick={addPart}>
                <span className="pluse-icon">+</span> <span>Add Part</span>
              </button>
              <Input
                style={{ gridColumn: "span 1" }}
                disabled={true}
                name="userName"
                required={true}
                disableAutocomplete={true}
                label={"User"}
                value={values["userName"]}
              />
              <BasicDatePicker
                style={{ gridColumn: "span 1" }}
                label={"Created Date"}
                disabled={true}
                isDateTime={true}
                value={dateRequestedCreated}
                name="dateRequired"
              ></BasicDatePicker>
            </div>
          </div>
          <div className="part-issue-body">
            <div className="grid-view-header">
              <div className="part-request-number">
                <b>PN</b>
              </div>
              <div className="part-request-number">
                <b>SN</b>
              </div>
              <div className="part-request-number">
                <b>GRN</b>
              </div>
              <div className="part-request-number">
                <b>Batch</b>
              </div>
              <div className="part-request-number">
                <b>QTY</b>
              </div>
              <div className="part-request-number">
                <b>UOM</b>
              </div>
            </div>
            <div className="grid-view-body">
              {defaults.locationId && defaults.siteId ? (
                values.partsList.map((part, partIdx) => (
                  <React.Fragment key={`${partIdx}`}>
                    <div className={`grid-view-row ${part == partSelected ? "selected" : ""}`}>
                      <Dropdowns
                        context={{
                          dropdownsData,
                          setDropdownsData,
                          setDropdownIds,
                          dropdownDefaultOptions,
                        }}
                        updateDropdown={updateDropdown}
                        resetDropdownsReload={resetDropdownsReload}
                        hideWhenDisabled={hideFieldsWhenDisabled.has(
                          dropdownNames[64]
                        )}
                        hideLabel={true}
                        key={64}
                        onOptionSelect={(value, data) =>
                          handleDropdownValueOption(value, dropdownNames[64], data, part)
                        }
                        showPagination={false}
                        placeholder={true}
                        data={dropdownsData.find((e) => e.id === 64)}
                        preSelectValue={part["partNumberId"]}
                      />
                      <Input
                        name="quantity_issue"
                        disableAutocomplete={true}
                        placeholder={"Serial Number"}
                        label={""}
                        disabled={!part.isSerialized}
                        value={part.sn}
                      />
                      <Input
                        name="quantity_issue"
                        disableAutocomplete={true}
                        placeholder={"GRN"}
                        label={""}
                        value={mainTransaction.qty ?? 0}
                      />
                      <Input
                        name="quantity_issue"
                        disableAutocomplete={true}
                        placeholder={"Batch"}
                        label={""}
                        value={mainTransaction.qty ?? 0}
                      />
                      <Input
                        name="quantity_issue"
                        isNumeric={true}
                        disableAutocomplete={true}
                        label={""}
                        value={mainTransaction.qty ?? 0}
                      />
                      <Dropdowns
                        context={{
                          dropdownsData,
                          setDropdownsData,
                          setDropdownIds,
                          dropdownDefaultOptions,
                        }}
                        updateDropdown={updateDropdown}
                        resetDropdownsReload={resetDropdownsReload}
                        hideWhenDisabled={hideFieldsWhenDisabled.has(
                          dropdownNames[6]
                        )}
                        hideLabel={true}
                        key={6}
                        onOptionSelect={(value, data) =>
                          handleDropdownValue(value, dropdownNames[6], data)
                        }
                        showPagination={false}
                        placeholder={true}
                        data={dropdownsData.find((e) => e.id === 6)}
                        preSelectValue={mainTransaction["siteId"]}
                        onKeyDown={(e) => {
                          if (e.shiftKey && e.key === "Enter") {
                            e.preventDefault();
                            addPart();
                          }
                        }}
                      />
                      <div
                        className="part-request-info"
                        onClick={() => deletePart(part, partIdx)}
                      >
                        <i className="icon-delete-new"></i>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              ) : (
                <div className="new-part-request-cards-cont-msg">
                  <i className="icon-info"></i>
                  <p>To add parts, please select a Location and Site first.</p>
                </div>
              )}
            </div>
            <div className={`grid-view-footer ${partSelected ? "selected" : ""}`}>
              <div className="grid-view-footer-location">
                <b>Additional Location Info</b>
                <Dropdowns
                  context={{
                    dropdownsData,
                    setDropdownsData,
                    setDropdownIds,
                    dropdownDefaultOptions,
                  }}
                  disabled={!partSelected}
                  updateDropdown={updateDropdown}
                  resetDropdownsReload={resetDropdownsReload}
                  hideWhenDisabled={hideFieldsWhenDisabled.has(
                    dropdownNames[20]
                  )}
                  key={20}
                  onOptionSelect={(value, data) =>
                    handleDropdownValue(value, dropdownNames[20], data)
                  }
                  showPagination={false}
                  data={dropdownsData.find((e) => e.id === 20)}
                  preSelectValue={!partSelected ? null : partSelected["rackId"]}
                />
                <Dropdowns
                  context={{
                    dropdownsData,
                    setDropdownsData,
                    setDropdownIds,
                    dropdownDefaultOptions,
                  }}
                  disabled={!partSelected}
                  updateDropdown={updateDropdown}
                  resetDropdownsReload={resetDropdownsReload}
                  hideWhenDisabled={hideFieldsWhenDisabled.has(
                    dropdownNames[21]
                  )}
                  key={21}
                  onOptionSelect={(value, data) =>
                    handleDropdownValue(value, dropdownNames[21], data)
                  }
                  showPagination={false}
                  data={dropdownsData.find((e) => e.id === 21)}
                  preSelectValue={
                    !partSelected ? null : partSelected["shelfId"]
                  }
                />
                <Dropdowns
                  context={{
                    dropdownsData,
                    setDropdownsData,
                    setDropdownIds,
                    dropdownDefaultOptions,
                  }}
                  disabled={!partSelected}
                  updateDropdown={updateDropdown}
                  resetDropdownsReload={resetDropdownsReload}
                  hideWhenDisabled={hideFieldsWhenDisabled.has(
                    dropdownNames[18]
                  )}
                  key={18}
                  onOptionSelect={(value, data) =>
                    handleDropdownValue(value, dropdownNames[18], data)
                  }
                  showPagination={false}
                  data={dropdownsData.find((e) => e.id === 18)}
                  preSelectValue={!partSelected ? null : partSelected["binId"]}
                />
              </div>
              <div className="grid-view-footer-cost">
                <b>Cost Information</b>
                <Input
                  name="quantity_issue"
                  isNumeric={true}
                  disableAutocomplete={true}
                  label={"Cost"}
                  required={true}
                  disabled={!partSelected}
                  value={partSelected?.qty}
                />
                <Dropdowns
                  context={{
                    dropdownsData,
                    setDropdownsData,
                    setDropdownIds,
                    dropdownDefaultOptions,
                  }}
                  updateDropdown={updateDropdown}
                  resetDropdownsReload={resetDropdownsReload}
                  hideWhenDisabled={hideFieldsWhenDisabled.has(
                    dropdownNames[74]
                  )}
                  key={74}
                  required={true}
                  disabled={!partSelected}
                  onOptionSelect={(value, data) =>
                    handleDropdownValue(value, dropdownNames[74], data)
                  }
                  showPagination={false}
                  data={dropdownsData.find((e) => e.id === 74)}
                  preSelectValue={
                    !partSelected ? null : partSelected["currencyID"]
                  }
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
